import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from 'ng-devui';
import { catchError, throwError } from 'rxjs';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { WorkReportStatus } from 'src/app/modules/shared/models/form/work-report-status.enum';
import { JgPhysicalInspUnitItemProgressSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-progress-search-request.model';
import { JgPhysicalInspUnitItemProgress } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-item-progress.model';
import {
  ProjectSectionUnitJgStatusColorMap,
  ProjectSectionUnitJgStatusMap,
  ProjectSectionUnitJgStatusOptions,
} from 'src/app/modules/shared/models/jg/project-section-unit-jg-status.enum';
import {
  ProjectItemType,
  ProjectItemTypeIndexList,
} from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import {
  ProjectSectionUnitStatusColorMap,
  ProjectSectionUnitStatusList,
  ProjectSectionUnitStatusMap,
} from 'src/app/modules/shared/models/project/project-section-unit-status.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { Page } from 'src/app/modules/shared/providers/request/page.type';
import { JgPhysicalInspUnitItemProgressService } from 'src/app/modules/shared/services/jg-physical-insp-unit-item-progress.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';

@Component({
  selector: 'app-handover-insp-entity-view',
  templateUrl: './handover-insp-entity-view.component.html',
  styleUrls: ['./handover-insp-entity-view.component.scss'],
})
export class HandoverInspEntityViewComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  searchRequest: JgPhysicalInspUnitItemProgressSearchRequest =
    new JgPhysicalInspUnitItemProgressSearchRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;
  sliceCount = 2;

  recordList: JgPhysicalInspUnitItemProgress[] = [];

  sectionList: ProjectSection[] = [];

  jgSectionList: ProjectSection[] = [];

  jgSectionId?: number;

  constructionSectionIds: number[] = [];

  isLM = false;
  // isLJ = false;

  recordTable: JgPhysicalInspUnitItemProgress[] = [];
  recordFakeTable: JgPhysicalInspUnitItemProgress[] = [];

  unitCascaderValue: any[] = [];

  sectionOrgMap: { [key: string]: TableColumnOption[] } = {};

  ProjectSectionUnitJgStatusMap = ProjectSectionUnitJgStatusMap;

  ProjectSectionUnitJgStatusColorMap = ProjectSectionUnitJgStatusColorMap;

  ProjectSectionUnitStatusMap = ProjectSectionUnitStatusMap;

  ProjectSectionUnitStatusColorMap = ProjectSectionUnitStatusColorMap;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loading: LoadingService,
    private projectSectionService: ProjectSectionService,
    private jgPhysicalInspUnitItemProgressService: JgPhysicalInspUnitItemProgressService,
    private globalService: GlobalService,
  ) {}

  ngOnInit(): void {
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;

        const sectionOrgMap: { [key: string]: TableColumnOption[] } = {};
        for (const section of projectSections ?? []) {
          for (const org of section.projectSectionOrganizations ?? []) {
            if (!sectionOrgMap[`${section.id!}`]) {
              sectionOrgMap[`${section.id!}`] = [];
            }
            sectionOrgMap[`${section.id!}`].push({
              label: org.organizationShortName!,
              value: org.organizationShortName!,
            });
          }
        }
        this.sectionOrgMap = sectionOrgMap;
        const jgSectionList = [];
        for (const section of projectSections) {
          if (section.type === OrganizationType.JG_CHECK) {
            jgSectionList.push(section);
          }
        }
        this.jgSectionList = jgSectionList;
        if (this.jgSectionList.length > 0) {
          this.jgSectionId = this.jgSectionList[0].id;
          this.onSectionChange();
        }
      });
  }

  onSectionChange() {
    setTimeout(() => {
      const jgSection = this.jgSectionList.find(
        (s) => s.id === this.jgSectionId,
      );
      if (jgSection) {
        const constructionSectionIds = [];
        if (jgSection.projectSectionSections) {
          for (const section of jgSection.projectSectionSections) {
            if (section.refSectionType === OrganizationType.CONSTRUCTION) {
              constructionSectionIds.push(section.refSectionId!);
            }
          }
        }
        this.constructionSectionIds = constructionSectionIds;
      }
    }, 50);
  }

  onUnitCascaderValueChange(events: any[]) {
    this.unitCascaderValue = events;
    // this.globalService.selectUnitCache = events;
    // if (this.unitCascaderValue.length > 0) {
    //   this.searchRequest.sectionId = +this.unitCascaderValue[0].split('#')[1];
    // }
    this.recordTable = [];
    this.recordFakeTable = [];
    this.initConfig();
  }

  getColor(status: string) {
    switch (status) {
      case WorkReportStatus.DRAFT:
        return '#000000';
      case WorkReportStatus.FINISH:
        return '#2b58cd';
      case WorkReportStatus.WAIT_SIGN:
      case WorkReportStatus.WAIT_SEAL:
        return '#A30014';
      case WorkReportStatus.REJECT_SIGN:
      case WorkReportStatus.REJECT_SEAL:
      case WorkReportStatus.CANCLE:
        return '#FF0000';
      default:
        return '#BDC3C7';
    }
  }

  initConfig() {
    for (const value of this.unitCascaderValue) {
      let result = value.split('#');
      const type = result[0] as ProjectItemType;
      const id = result[1];
      switch (type) {
        case ProjectItemType.PROJECT_SECTION:
          this.searchRequest.sectionId = +id;
          this.searchRequest.dwCode = '';
          this.searchRequest.subDwCode = '';
          this.searchRequest.fbCode = '';
          this.searchRequest.subFbCode = '';
          this.searchRequest.fxCode = '';
          break;
        case ProjectItemType.DW:
          this.searchRequest.dwCode = id;
          this.searchRequest.subDwCode = '';
          this.searchRequest.fbCode = '';
          this.searchRequest.subFbCode = '';
          this.searchRequest.fxCode = '';
          break;
        case ProjectItemType.SUB_DW:
          this.searchRequest.subDwCode = id;
          this.searchRequest.fbCode = '';
          this.searchRequest.subFbCode = '';
          this.searchRequest.fxCode = '';
          break;
        case ProjectItemType.FB:
          this.searchRequest.fbCode = id;
          this.searchRequest.subFbCode = '';
          this.searchRequest.fxCode = '';
          break;
        case ProjectItemType.SUB_FB:
          this.searchRequest.subFbCode = id;
          this.searchRequest.fxCode = '';
          break;
        case ProjectItemType.FX:
          this.searchRequest.fxCode = id;
          break;
        default:
          break;
      }
    }
    this.isLM = false;
    // this.isLJ = false;
    if (
      this.searchRequest.dwCode &&
      (this.searchRequest.dwCode.indexOf('L') === 0 ||
        this.searchRequest.dwCode.indexOf('J') === 0)
    ) {
      this.isLM = true;
      // if (this.searchRequest.dwCode.indexOf('J') === 0) {
      //   this.isLJ = true;
      // }
    }
    const defaultColumn: TableColumnConfig[] = [
      {
        name: '单位工程',
        key: 'dwName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'dwName',
      },
      {
        name: '单位工程<br>单元',
        key: 'subDwName',
        type: TableColumnType.text,
        width: 60,
        queryable: true,
        queryKey: 'subDwName',
      },
      {
        name: '分部工程',
        key: 'fbName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'fbName',
      },
      {
        name: '分部工程单元',
        key: 'subFbName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'subFbName',
      },
      {
        name: '分项工程',
        key: 'fxName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'fxName',
      },
    ];

    const fixedColumns: TableColumnConfig[] = [
      {
        name: '分项工程单元',
        key: 'sectionName',
        type: TableColumnType.text,
        width: 140,
        align: 'left',
        queryable: true,
        queryKey: 'sectionName',
        separator: true,
      },
      {
        name: '工程类型',
        key: 'projectTypeName',
        type: TableColumnType.text,
        width: 140,
        queryable: true,
        queryKey: 'projectTypeName',
      },
      {
        name: '施工单位',
        key: 'constructionOrgName',
        type: TableColumnType.options,
        options: this.sectionOrgMap[`${this.searchRequest.sectionId}`],
        width: 80,
        queryable: true,
        queryKey: 'constructionOrgName',
      },
    ];
    if (this.isLM) {
      fixedColumns.push({
        name: '段',
        key: 'code',
        type: TableColumnType.text,
        width: 40,
        queryable: true,
        queryKey: 'code',
      });
      fixedColumns.push({
        name: '分段里程',
        key: 'mileage',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'mileage',
      });
    }

    fixedColumns.push({
      name: '施工状态',
      key: 'status',
      type: TableColumnType.options,
      options: ProjectSectionUnitStatusList,
      width: 80,
      queryable: true,
      queryKey: 'status',
    });
    fixedColumns.push({
      name: '施工资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 80,
    });
    fixedColumns.push({
      name: '监理资料',
      key: 'mark',
      type: TableColumnType.text,
      width: 80,
    });
    // if (this.isLJ) {
    //   fixedColumns.push({
    //     name: '区',
    //     key: 'partitionCode',
    //     type: TableColumnType.text,
    //     width: 40,
    //     queryable: true,
    //     queryKey: 'partitionCode',
    //   });
    //   fixedColumns.push({
    //     name: '层',
    //     key: 'layerCode',
    //     type: TableColumnType.text,
    //     width: 40,
    //     queryable: true,
    //     queryKey: 'layerCode',
    //   });
    // }

    fixedColumns.push({
      name: '交工检测项目',
      key: 'jgInspItemName',
      type: TableColumnType.text,
      width: 120,
      queryable: true,
      queryKey: 'jgInspItemName',
    });
    fixedColumns.push({
      name: '交工状态',
      key: 'jgStatus',
      type: TableColumnType.options,
      options: ProjectSectionUnitJgStatusOptions,
      width: 70,
      queryable: true,
      queryKey: 'jgStatus',
    });
    fixedColumns.push({
      name: '交工报检单',
      key: 'report',
      type: TableColumnType.text,
      width: 80,
    });
    fixedColumns.push({
      name: '交工检测报告',
      key: 'report',
      type: TableColumnType.text,
      width: 240,
    });
    fixedColumns.push({
      name: '备注',
      key: 'comment',
      type: TableColumnType.text,
      width: 120,
    });
    if (this.unitCascaderValue.length > 0) {
      let value = (
        this.unitCascaderValue[this.unitCascaderValue.length - 1] as string
      ).split('#');
      const type = value[0] as ProjectItemType;
      this.sliceCount = ProjectItemTypeIndexList.indexOf(type);
    }

    const columns: TableColumnConfig[] = [
      ...defaultColumn.slice(this.sliceCount),
      ...fixedColumns,
    ];
    console.log(columns);
    this.config = {
      hasIndex: true,
      columns,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 56);

    if (this.unitCascaderValue.length > 0) {
      this.resetSearch();
    }
  }

  onScroll(event: any) {
    if (this.recordFakeTable.length > 0) {
      this.recordFakeTable = [];
    }
  }

  onScrollEnd($event?: any) {
    const startIndex = Math.floor(this.scroll?.nativeElement.scrollTop / 40);
    const viewportHeight =
      this.scroll?.nativeElement.clientHeight - (this.isOpen ? 120 : 80);
    let endIndex = Math.ceil(viewportHeight / 40) + startIndex;
    if (endIndex > this.recordList.length - 1) {
      endIndex = this.recordList.length - 1;
    }
    const offset = this.scroll?.nativeElement.scrollTop % 40;
    this.scrollTop = this.scroll?.nativeElement.scrollTop - offset;
    this.scrollIndex = startIndex;

    this.recordFakeTable = this.handleTable(
      JSON.parse(
        JSON.stringify(this.recordList.slice(startIndex, endIndex + 1)),
      ),
    );
  }

  private handleTable(recordTable: JgPhysicalInspUnitItemProgress[]) {
    if (recordTable.length === 0) {
      return [];
    }
    console.log('recordTable');
    let index = recordTable.length - 1;
    while (index > 0) {
      if (recordTable[index].dwCode === recordTable[index - 1].dwCode) {
        recordTable[index].dwCode = '';
        recordTable[index].dwName = '';
        recordTable[index - 1].dwSpan = !!recordTable[index].dwSpan
          ? recordTable[index].dwSpan! + 1
          : 2;

        if (recordTable[index].subDwCode === recordTable[index - 1].subDwCode) {
          recordTable[index].subDwCode = '';
          recordTable[index].subDwName = '';
          recordTable[index - 1].subDwSpan = recordTable[index].subDwSpan
            ? recordTable[index].subDwSpan! + 1
            : 2;
          if (recordTable[index].fbCode === recordTable[index - 1].fbCode) {
            recordTable[index].fbCode = '';
            recordTable[index].fbName = '';
            recordTable[index - 1].fbSpan = recordTable[index].fbSpan
              ? recordTable[index].fbSpan! + 1
              : 2;
            if (
              recordTable[index].subFbCode === recordTable[index - 1].subFbCode
            ) {
              recordTable[index].subFbCode = '';
              recordTable[index].subFbName = '';
              recordTable[index - 1].subFbSpan = recordTable[index].subFbSpan
                ? recordTable[index].subFbSpan! + 1
                : 2;
              if (recordTable[index].fxCode === recordTable[index - 1].fxCode) {
                recordTable[index].fxCode = '';
                recordTable[index].fxName = '';
                recordTable[index - 1].fxSpan = recordTable[index].fxSpan
                  ? recordTable[index].fxSpan! + 1
                  : 2;
                // 如果存在分段分层
                if (this.isLM) {
                  if (
                    recordTable[index].sectionCode ===
                    recordTable[index - 1].sectionCode
                  ) {
                    recordTable[index].sectionCode = '';
                    recordTable[index].sectionName = '';
                    recordTable[index - 1].sectionSpan = recordTable[index]
                      .sectionSpan
                      ? recordTable[index].sectionSpan! + 1
                      : 2;
                    // if (this.isLJ) {
                    //   if (
                    //     recordTable[index].code === recordTable[index - 1].code
                    //   ) {
                    //     recordTable[index].code = '';
                    //     recordTable[index].name = '';
                    //     recordTable[index - 1].codeSpan = recordTable[index]
                    //       .codeSpan
                    //       ? recordTable[index].codeSpan! + 1
                    //       : 2;
                    //     if (
                    //       recordTable[index].partitionCode ===
                    //       recordTable[index - 1].partitionCode
                    //     ) {
                    //       recordTable[index].partitionCode = '';
                    //       recordTable[index].partitionName = '';
                    //       recordTable[index - 1].partitionSpan = recordTable[
                    //         index
                    //       ].partitionSpan
                    //         ? recordTable[index].partitionSpan! + 1
                    //         : 2;
                    //     }
                    //   }
                    // }
                  }
                }
              }
            }
          }
        }
      } else {
        if (!recordTable[index].subDwCode) {
          recordTable[index].subDwCode = ' ';
        }
      }
      recordTable[index].sectionItemIndex = ProjectItemTypeIndexList.indexOf(
        recordTable[index].sectionItemType!,
      );
      index--;
    }
    recordTable[0].sectionItemIndex = ProjectItemTypeIndexList.indexOf(
      recordTable[0].sectionItemType!,
    );
    if (!recordTable[0].dwCode) {
      recordTable[0].dwCode = ' ';
    }
    if (!recordTable[0].subDwCode) {
      recordTable[0].subDwCode = ' ';
    }
    if (!recordTable[0].fbCode) {
      recordTable[0].fbCode = ' ';
    }
    if (!recordTable[0].subFbCode) {
      recordTable[0].subFbCode = ' ';
    }
    if (!recordTable[0].fxCode) {
      recordTable[0].fxCode = ' ';
    }
    if (this.isLM) {
      if (!recordTable[0].code) {
        recordTable[0].code = ' ';
      }
      // if (this.isLJ) {
      //   if (!recordTable[0].sectionCode) {
      //     recordTable[0].sectionCode = ' ';
      //   }
      //   if (!recordTable[0].partitionCode) {
      //     recordTable[0].partitionCode = ' ';
      //   }
      // }
    }
    return recordTable;
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  searchRecord() {
    const loading = this.loading.open();
    // this.searchRequest.fullCode = !!this.searchWbsCode
    //   ? this.searchWbsCode
    //   : undefined;
    // if (this.isBeamFilter) {
    //   this.searchRequest.projectTypeCode = '2001.001.005.027';
    // }
    if (this.isLM) {
      this.searchRequest.sectionItemType = ProjectItemType.SEGMENT;
    } else {
      if (this.searchRequest['sectionName']) {
        this.searchRequest['name'] = this.searchRequest['sectionName'];
        this.searchRequest['sectionName'] = undefined;
      }
    }
    // this.searchRequest.hasLJ =
    //   this.searchRequest.sectionItemType === ProjectItemType.SEGMENT;
    this.jgPhysicalInspUnitItemProgressService
      .search(this.searchRequest, this.pager.pageIndex - 1, this.pager.pageSize)
      .pipe(
        catchError((error) => {
          loading.loadingInstance.close();
          return throwError(error);
        }),
      )
      .subscribe((data: Page<JgPhysicalInspUnitItemProgress>) => {
        loading.loadingInstance.close();
        this.globalService.savePager(this.pager);
        // this.currentCheckList = [];
        // this.hiddenHost.viewContainerRef.clear();
        if (!!data) {
          this.recordList = data.content ?? [];
          if (!this.isLM) {
            for (const item of this.recordList) {
              item.sectionCode = item.code;
              item.sectionName = item.name;
            }
          }
        }
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        this.pager.total = data.totalElements;
        this.onScrollEnd();
      });
  }

  resetSearch() {
    console.log(this.pager);
    this.searchRequest = new JgPhysicalInspUnitItemProgressSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.jgSectionId = this.jgSectionId;
    this.searchRequest.sectionItemType = ProjectItemType.SECTION;
    this.pager.pageIndex = 1;
    for (const value of this.unitCascaderValue) {
      let result = value.split('#');
      const type = result[0] as ProjectItemType;
      const id = result[1];
      switch (type) {
        case ProjectItemType.PROJECT_SECTION:
          this.searchRequest.sectionId = +id;
          break;
        case ProjectItemType.DW:
          this.searchRequest.dwCode = id;
          break;
        case ProjectItemType.SUB_DW:
          this.searchRequest.subDwCode = id;
          break;
        case ProjectItemType.FB:
          this.searchRequest.fbCode = id;
          break;
        case ProjectItemType.SUB_FB:
          this.searchRequest.subFbCode = id;
          break;
        case ProjectItemType.FX:
          this.searchRequest.fxCode = id;
          break;
        default:
          break;
      }
    }
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    this.searchRequest = new JgPhysicalInspUnitItemProgressSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.jgSectionId = this.jgSectionId;
    this.searchRequest.sectionItemType = ProjectItemType.SECTION;
    for (const value of this.unitCascaderValue) {
      let result = value.split('#');
      const type = result[0] as ProjectItemType;
      const id = result[1];
      switch (type) {
        case ProjectItemType.PROJECT_SECTION:
          this.searchRequest.sectionId = +id;
          break;
        case ProjectItemType.DW:
          this.searchRequest.dwCode = id;
          break;
        case ProjectItemType.SUB_DW:
          this.searchRequest.subDwCode = id;
          break;
        case ProjectItemType.FB:
          this.searchRequest.fbCode = id;
          break;
        case ProjectItemType.SUB_FB:
          this.searchRequest.subFbCode = id;
          break;
        case ProjectItemType.FX:
          this.searchRequest.fxCode = id;
          break;
        default:
          break;
      }
    }
    Object.assign(this.searchRequest, data);
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  afterEdit(data: { row: number; key: string }) {
    const { row, key } = data;
    // this.editRecord(row);
  }

  editing: any = {};

  edit(key: string) {
    this.editing[key] = true;
    console.log(this.editing);
  }

  onBlur(id: number, comment: string) {
    this.editing = {};
    this.jgPhysicalInspUnitItemProgressService
      .update({
        id,
        comment,
      })
      .subscribe(() => {
        this.searchRecord();
      });
  }
}
